import React from "react"
import { DemoContainer } from "@mui/x-date-pickers/internals/demo"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker"

const DateTimeSelector = ({ label, value, onChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DateTimePicker"]}>
        <DateTimePicker
          value={value}
          label={label}
          onChange={onChange}
          slotProps={{
            textField: {
              inputProps: {
                style: {
                  padding: "16.5px 14px", // Disable all padding
                },
              },
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  )
}

export default DateTimeSelector
